var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('basic-chart',{ref:_vm.namespace,attrs:{"namespace":_vm.namespace,"div-name":_vm.namespace+'-chartDiv',"parsedData":_vm.parsedData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }